export const Bhuj = {
    title: "Bhuj",
    title1: "(Gateway to the Rann of Kutch)",

    attractions: [
        {
            name: "Aina Mahal (Hall of Mirrors)",
            description: "Aina Mahal is a stunning 18th-century palace built by Rao Lakhpatji, showcasing a blend of Indian and European architecture. The palace is famous for its intricate mirror work, Venetian-style chandeliers, and a unique music room with handmade instruments. It offers a glimpse into the royal lifestyle of the Kutch rulers.",
            location: "Near Hamirsar Lake, Bhuj",
            timings: "9:00 AM to 12:00 PM, 3:00 PM to 6:00 PM",
            ticket: "INR 20 for Indians, INR 200 for Foreigners",
            bestTimeToVisit: "October to March",
            activities: [
                "Admire the mirror work and architecture",
                "Explore the royal artifacts and exhibits",
                "Visit the music room with ancient instruments",
                "Learn about the history of the Kutch dynasty",
                "Photography of the palace interiors"
            ],
            mapLink: "https://maps.app.goo.gl/xyz123",
        },
        {
            name: "Prag Mahal",
            description: "Prag Mahal is a 19th-century Gothic-style palace designed by Colonel Henry Saint Wilkins. It features a grand clock tower, intricate stone carvings, and a Durbar Hall with Belgian glass windows. The palace is a testament to the grandeur of the Kutch rulers and offers panoramic views of Bhuj from its tower.",
            location: "Near Aina Mahal, Bhuj",
            timings: "9:00 AM to 12:00 PM, 3:00 PM to 6:00 PM",
            ticket: "INR 20 for Indians, INR 200 for Foreigners",
            bestTimeToVisit: "October to March",
            activities: [
                "Climb the clock tower for city views",
                "Explore the Gothic architecture",
                "Photography of the Durbar Hall",
                "Learn about the history of the palace",
                "Visit the nearby Aina Mahal"
            ],
            mapLink: "https://maps.app.goo.gl/xyz123",
        },
        {
            name: "Kutch Museum",
            description: "The oldest museum in Gujarat, Kutch Museum houses a vast collection of artifacts, including ancient coins, tribal crafts, and exhibits on the history of the Kutchi script. It also features a unique section dedicated to the extinct Kutchi script and the region's tribal culture.",
            location: "Near Hamirsar Lake, Bhuj",
            timings: "10:00 AM to 1:00 PM, 2:30 PM to 5:30 PM",
            ticket: "INR 10 for Indians, INR 100 for Foreigners",
            bestTimeToVisit: "October to March",
            activities: [
                "Explore the tribal artifacts",
                "Learn about the Kutchi script",
                "Admire the ancient coin collection",
                "Visit the embroidery and textile section",
                "Photography of the exhibits"
            ],
            mapLink: "https://maps.app.goo.gl/xyz123",
        },
        {
            name: "Hamirsar Lake",
            description: "A serene man-made lake located in the heart of Bhuj, Hamirsar Lake is a popular spot for locals and tourists alike. Surrounded by ghats and temples, the lake offers a peaceful retreat and is a great place to relax and enjoy the natural beauty.",
            location: "Central Bhuj",
            timings: "Open 24 hours",
            ticket: "Free Entry",
            bestTimeToVisit: "Early Morning or Evening",
            activities: [
                "Take a leisurely walk around the lake",
                "Enjoy the sunset views",
                "Visit nearby temples",
                "Photography of the scenic surroundings",
                "Relax and unwind by the water"
            ],
            mapLink: "https://maps.app.goo.gl/xyz123",
        },
        {
            name: "Bhujodi Haat",
            description: "Bhujodi Haat is a vibrant market known for its traditional Kutchi handicrafts, textiles, and embroidery. It is a hub for artisans and a great place to shop for souvenirs, including Bandhani sarees, leather goods, and handmade jewelry.",
            location: "Bhujodi Village, 8 km from Bhuj",
            timings: "10:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Shop for traditional Kutchi crafts",
                "Interact with local artisans",
                "Buy Bandhani sarees and embroidered textiles",
                "Explore leather goods and jewelry",
                "Photography of the vibrant market"
            ],
            mapLink: "https://maps.app.goo.gl/xyz123",
        },
        {
            name: "Black Hill (Kalo Dungar)",
            description: "The highest point in Kutch, Black Hill offers breathtaking views of the Great Rann of Kutch. It is also home to a 400-year-old Dattatreya Temple and is believed to be a sacred spot. The panoramic view of the white desert from here is mesmerizing.",
            location: "80 km from Bhuj",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "November to February",
            activities: [
                "Enjoy the panoramic views of the Rann",
                "Visit the Dattatreya Temple",
                "Photography of the desert landscape",
                "Experience the sunset over the Rann",
                "Meditate in the serene surroundings"
            ],
            mapLink: "https://maps.app.goo.gl/xyz123",
        },
        {
            name: "White Desert (Great Rann of Kutch)",
            description: "The Great Rann of Kutch is a vast salt desert that stretches as far as the eye can see. During the monsoon, it is submerged in water, but in winter, it transforms into a white crystalline landscape. It is one of the most unique and surreal places to visit in India.",
            location: "90 km from Bhuj",
            timings: "Open 24 hours",
            ticket: "Free Entry",
            bestTimeToVisit: "November to February",
            activities: [
                "Experience the vast white desert",
                "Photography of the surreal landscape",
                "Visit during the Rann Utsav festival",
                "Enjoy camel rides and cultural programs",
                "Stargazing at night"
            ],
            mapLink: "https://maps.app.goo.gl/xyz123",
        },
        {
            name: "Dholavira",
            description: "Dholavira is an ancient Indus Valley Civilization site, dating back to 4500 years ago. It is one of the five largest Harappan sites and showcases advanced urban planning, water conservation systems, and archaeological remains.",
            location: "220 km from Bhuj",
            timings: "8:00 AM to 6:00 PM",
            ticket: "INR 40 for Indians, INR 600 for Foreigners",
            bestTimeToVisit: "October to March",
            activities: [
                "Explore the ancient ruins",
                "Learn about the Indus Valley Civilization",
                "Photography of the archaeological site",
                "Visit the museum showcasing artifacts",
                "Enjoy the scenic surroundings"
            ],
            mapLink: "https://maps.app.goo.gl/xyz123",
        },
        {
            name: "Shree Swaminarayan Temple",
            description: "A beautiful temple dedicated to Lord Swaminarayan, this temple is known for its intricate carvings and peaceful ambiance. It is a place of worship and a center for spiritual learning.",
            location: "Bhuj",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Attend the morning and evening aarti",
                "Admire the temple architecture",
                "Meditate in the peaceful surroundings",
                "Learn about the Swaminarayan sect",
                "Photography of the temple"
            ],
            mapLink: "https://maps.app.goo.gl/xyz123",
        },
        {
            name: "Vande Mataram Memorial",
            description: "A unique memorial dedicated to the victims of the 2001 Bhuj earthquake, this site features a museum and a memorial wall with the names of the deceased. It is a place of remembrance and reflection.",
            location: "Bhuj",
            timings: "10:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Visit the museum",
                "Pay respects at the memorial wall",
                "Learn about the earthquake's impact",
                "Photography of the memorial",
                "Reflect on the resilience of the people"
            ],
            mapLink: "https://maps.app.goo.gl/xyz123",
        },
        {
            name: "Sharad Baug Palace",
            description: "A former royal residence, Sharad Baug Palace is now a museum showcasing the history and culture of the Kutch region. It houses a collection of royal artifacts, photographs, and exhibits.",
            location: "Bhuj",
            timings: "10:00 AM to 6:00 PM",
            ticket: "INR 20 for Indians, INR 200 for Foreigners",
            bestTimeToVisit: "October to March",
            activities: [
                "Explore the royal artifacts",
                "Learn about the history of Kutch",
                "Photography of the palace",
                "Visit the nearby garden",
                "Admire the architecture"
            ],
            mapLink: "https://maps.app.goo.gl/xyz123",
        },
        {
            name: "Bhujodi Handicraft Village",
            description: "A village known for its traditional handicrafts, Bhujodi is a hub for artisans specializing in weaving, embroidery, and pottery. Visitors can interact with artisans and watch them create beautiful handmade products.",
            location: "8 km from Bhuj",
            timings: "10:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Interact with local artisans",
                "Watch live demonstrations of handicrafts",
                "Shop for traditional products",
                "Learn about Kutchi crafts",
                "Photography of the village"
            ],
            mapLink: "https://maps.app.goo.gl/xyz123",
        },
        {
            name: "Prag Mahal Garden",
            description: "A beautifully maintained garden located near Prag Mahal, this spot is perfect for a leisurely stroll. It features lush greenery, fountains, and a peaceful ambiance.",
            location: "Near Prag Mahal, Bhuj",
            timings: "8:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Take a leisurely walk",
                "Enjoy the serene surroundings",
                "Photography of the garden",
                "Relax and unwind",
                "Visit nearby Prag Mahal"
            ],
            mapLink: "https://maps.app.goo.gl/xyz123",
        },
        {
            name: "Ramkund Stepwell",
            description: "An ancient stepwell located near Bhuj, Ramkund is known for its intricate carvings and architectural beauty. It was once a source of water for the local community and is now a historical site.",
            location: "20 km from Bhuj",
            timings: "8:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Admire the stepwell architecture",
                "Photography of the carvings",
                "Learn about its historical significance",
                "Enjoy the peaceful surroundings",
                "Visit nearby attractions"
            ],
            mapLink: "https://maps.app.goo.gl/xyz123",
        },
        {
            name: "Kutch Bustard Sanctuary",
            description: "A wildlife sanctuary dedicated to the conservation of the Great Indian Bustard, this sanctuary is home to various species of birds and wildlife. It is a great place for birdwatching and nature enthusiasts.",
            location: "50 km from Bhuj",
            timings: "6:00 AM to 6:00 PM",
            ticket: "INR 50 for Indians, INR 300 for Foreigners",
            bestTimeToVisit: "November to February",
            activities: [
                "Birdwatching",
                "Explore the wildlife",
                "Photography of the sanctuary",
                "Learn about conservation efforts",
                "Enjoy the natural beauty"
            ],
            mapLink: "https://maps.app.goo.gl/xyz123",
        }
    ]
};